import { render, staticRenderFns } from "./UnificadorPedido.vue?vue&type=template&id=2cd4a556&scoped=true"
import script from "./UnificadorPedido.vue?vue&type=script&lang=js"
export * from "./UnificadorPedido.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd4a556",
  null
  
)

export default component.exports